module.exports = __webpack_public_path__ + "media/images/elionline/icons/side_menu_gruppi_attivo-ea76b0b9cca84c3e69a64f24fcd2dc7a.svg";